export {default} from './OrderDetail.connect';
